import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useSpeechRecognition } from "react-speech-kit";

export default function SpeechRecognition() {
  let [msg, setMsg] = useState("");
  const { listen, listening, stop } = useSpeechRecognition({
    onResult: (result) => {
      setMsg(result);
    },
  });
  function handleChange(e) {
    setMsg(e.target.value);
  }
  function handleStop() {
    stop();
    setMsg("");
  }
  return (
    <>
      {listening && <Typography>Go ahead I'm listening 🎤</Typography>}

      <TextField
        id="outlined-multiline-static"
        label="Message"
        multiline
        rows={5}
        value={msg}
        onChange={handleChange}
        sx={{ mb: 3, mt: 5 }}
        fullWidth
      />
      <Stack direction="row" spacing={2}>
        <Button variant="contained" size="large" onClick={listen}>
          Listen
        </Button>
        <Button variant="contained" size="large" onClick={handleStop}>
          Stop
        </Button>
      </Stack>
    </>
  );
}
